export { LeadMessageTranscription } from './LeadMessageTranscription';
